<script>
  export let alt = 'Изображение',
  src,
  type = 'default';

  let preload, error;

  const errorHandle = () => error = true;
  const hidePreload = () => preload = false;
</script>

<div
  class="tile_img position-relative"
  class:rectangle={type === 'rectangle'}
  class:square={type === 'square'}
  class:default={type === 'default'}
  class:vertical={type === 'vertical'}
  class:smallHeight={type === 'smallHeight'}
  class:error={error}
  class:preload={preload}
>
  <img
    {src}
    {alt}
    class="d-block"
    on:error={errorHandle}
    on:load={hidePreload}
  />
</div>


<style>
  .tile_img.preload {
     &:before {
        content: '';
        transition: opacity 0.3s;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-position: center;
        background-image: url('/img/icons/preloader.svg');
        background-color: lightgray;
        background-repeat: no-repeat;
     }
  }

  .tile_img.default,
  .tile_img.rectangle,
  .tile_img.square,
  .tile_img.vertical,
  .tile_img.smallHeight
  {
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .tile_img.default {
    padding-top: 56.175%;
  }

  .tile_img.smallHeight {
    padding-top: 32%;
  }

  .tile_img.rectangle {
    padding-top: 80%;
  }

  .tile_img.square {
    padding-top: 100%;
  }

  .tile_img.vertical {
    padding-top: 141%;
  }

  .tile_img.error {
    padding-top: 56.25%;
    position: relative;
    &:before {
      content: 'Не удалось загрузить изображение :(';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-image: url('/img/default_img.png');
      background-size: cover;
      color: white;
      display: flex;
      text-align: center;
      align-items: center;
    }
  }
  .tile_img {
    img {
      width: 100%;
    }
  }
</style>